import { PublicKey } from '@solana/web3.js';
import { getSolanaConnection } from '../connection';

function formatLamportsToSolDisplay(lamports) {
  const solAmount = Number(lamports) / 1000000000;

  return solAmount.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 9,
  });
}

export async function fetchWalletSolBalance(walletPublicKey) {
  if (!walletPublicKey) {
    throw new Error('Wallet public key is required.');
  }

  const connection = getSolanaConnection();
  const lamports = await connection.getBalance(new PublicKey(walletPublicKey), 'confirmed');

  return {
    lamports,
    solDisplay: formatLamportsToSolDisplay(lamports),
  };
}